import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'

import {ButtonVariant} from './ButtonTypes'

type IconButtonProps = {
  icon: ReactNode
  onClick: () => void
  variant?: ButtonVariant
  isDisabled?: boolean
  isOutlined?: boolean
  ariaLabel?: string
}

export const IconButton: FC<React.PropsWithChildren<IconButtonProps>> = ({
  icon,
  onClick,
  variant = ButtonVariant.tertiary,
  isDisabled,
  isOutlined = false,
  ariaLabel,
}) => {
  const backgroundColor = theme.palette.button[variant].main
  const hoverBackgroundColor = theme.palette.button[variant].dark
  const outlineColor = theme.palette.button[variant].outlineColor

  return (
    <>
      <button
        type="button"
        className={cn('button', isDisabled && 'disabled', isOutlined && 'outlined')}
        disabled={isDisabled}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {icon}
      </button>

      <style jsx>{`
        .button {
          padding: ${theme.spacing[1.5]};
          border-radius: 5px;
          cursor: pointer;
          background-color: ${backgroundColor};
          transition: background-color ${HOVER_TRANSITION}ms ease-in-out;
        }
        .outlined {
          box-shadow: inset 0px 0px 0px 1px ${outlineColor};
        }
        .button:hover {
          background-color: ${hoverBackgroundColor};
        }
        .disabled {
          cursor: default;
        }
      `}</style>
    </>
  )
}
